module.exports = __webpack_public_path__ + "static/media/simunation-logo.9a71732c.png";